import React from "react";

/**
 * Composant officiel pour afficher le logo TPCO.
 * - variant="light"  : fond clair (header, pages claires)
 * - variant="dark"   : fond sombre → place le logo dans une carte blanche soignée
 */
export const TpcoLogo = ({ variant = "light", size = "md", className = "" }) => {
  const sizes = { sm: "h-10", md: "h-14", lg: "h-16", xl: "h-20" };
  const h = sizes[size] || sizes.md;

  if (variant === "dark") {
    return (
      <div
        className={`inline-flex items-center justify-center bg-white rounded-xl shadow-[0_8px_24px_-12px_rgba(0,0,0,0.4)] px-4 py-3 ${className}`}
      >
        <img src="/logo-tpco.png" alt="TPCO Sénégal · Touba Pro Construction" className={`${h} w-auto object-contain`} />
      </div>
    );
  }

  return (
    <img
      src="/logo-tpco.png"
      alt="TPCO Sénégal · Touba Pro Construction"
      className={`${h} w-auto object-contain ${className}`}
    />
  );
};

export default TpcoLogo;
